const shippingUrls = {
  "de-de": "https://www.vistaprint.de/lieferung"
};

export { shippingUrls };
